<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      {{ title }}
    </mat-card-title>
  </mat-card-header>

  <!-- Form -->
  <mat-card-content style="margin: 2em 0; max-height: 65vh; overflow: auto">
    <div [innerHTML]="message"></div>

    @for (item of inputName; track $index) {
      <mat-form-field class="mt-3">
        <mat-label>{{ item }}</mat-label>
        <input matInput [(ngModel)]="inputValue[$index]" required />
      </mat-form-field>
    }
  </mat-card-content>

  <mat-divider />

  <!-- Botones -->
  <mat-card-actions class="gap-3" style="margin: 0.5em">
    <button
      mat-raised-button
      color="primary"
      (click)="matDialogRef.close(inputValue)"
      [disabled]="!inputValue"
    >
      {{ btnOkText }}
    </button>
    <button mat-raised-button (click)="matDialogRef.close(false)">
      {{ btnCancelText }}
    </button>
  </mat-card-actions>

  <!-- Progress Bar  -->
  <!-- <mat-card-footer>
      <mat-progress-bar
        [mode]="loading ? 'indeterminate' : 'determinate'"
      ></mat-progress-bar>
    </mat-card-footer> -->
</mat-card>
